// src/components/ErrorBoundary.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  
  static getDerivedStateFromError(error: any) { 
    return { hasError: true, error }; 
  }
  
  componentDidCatch(error: any, errorInfo: any) { 
    console.error("Uncaught error:", error, errorInfo); 
  }
  
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-red-50 dark:bg-red-900/20 p-6 text-center font-sans">
          <div className="max-w-md">
            <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-red-700 dark:text-red-400 mb-2">Er ging iets mis</h1>
            <p className="text-red-600 dark:text-red-300 mb-4 text-sm">De app is vastgelopen. Probeer de pagina te verversen.</p>
            <div className="bg-white dark:bg-slate-800 p-3 rounded border border-red-200 dark:border-red-800 text-left overflow-auto text-xs font-mono text-slate-500 dark:text-slate-300 max-h-32">
                {this.state.error?.toString()}
            </div>
            <button onClick={() => window.location.reload()} className="mt-6 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Verversen</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}